module.exports = __webpack_public_path__ + "static/media/Start Me Up.3d423d7c.jpg";